export enum SessionType {
  Unknown = 'Unknown',
  BattingPractice = 'BattingPractice',
  Standard = 'Standard',
  Adhoc = 'Adhoc',
  BouncingBallCalibration = 'BouncingBallCalibration',
}
